import { Link } from "react-router-dom";
import { Col, Container } from "reactstrap";
import { Error3 } from "../../../../data/pages/Pages";
import { routes } from "../../../../routers/routes";

const Error403 = () => {
  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <div className="error-wrapper">
        <Container>
          <div className="svg-wrraper">
            <Error3 />
          </div>
          <Col md="8" className="offset-md-2">
            <h3>Sorry, Something Goes Wrong</h3>
            <p className="sub-content">{"The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved."}</p>
            <Link to={routes.Dashboard.Default} className="btn btn-primary btn-lg">
              {"BACK TO HOME PAGE"}
            </Link>
          </Col>
        </Container>
      </div>
    </div>
  );
};

export default Error403;
